import type { Dispatch } from 'redux'
import { Cart, ResponseError, nativeAppHeaders } from '@ynap/api-utils'
import { timeout, delay } from '@ynap/promise-utils'
import { REMOVE_ITEM_REQUEST, REMOVE_ITEM_SUCCESS, REMOVE_ITEM_ERROR } from '../constants/ActionTypes'
import { notifyBasketChanged, getLocale } from '@ynap/cart-state'
import { getWatsonConfig, getTimeout, getDelay } from '@ynap/cart-state/src/selectors/getConfig'
import { getAdditionalCheckoutHeaders } from '../utils/checkoutActionUtils'
import { StoreState } from 'app/state/types'
import { ShoppingCart } from 'app/types/common-types'

type RemoveLineItemResponseData = {
    orderId: string
    shoppingCart: ShoppingCart
    version: string
    resourceId: string
}

export default function removeLineItem(partNumber: string, orderItemId: number, quantity: number, clearMessages?: boolean) {
    return (dispatch: Dispatch, getState: () => StoreState, fetch: WindowOrWorkerGlobalScope['fetch']) => {
        const state = getState()
        const watsonConfig = getWatsonConfig(state)
        const { langId } = getLocale(state)
        const additionalHeaders = {
            ...nativeAppHeaders(state.deviceType),
            ...getAdditionalCheckoutHeaders(state),
        }
        dispatch(removeLineItemRequest(partNumber, orderItemId))

        const request = Cart.deleteOrderItem({ partNumber, orderItemId, quantity, ...watsonConfig, langId, additionalHeaders, clearMessages })

        return delay(timeout(fetch(request), getTimeout(state)), getDelay(state))
            .then((response: Response) => {
                if (!response.ok) {
                    throw new ResponseError(response)
                }
                return response.json()
            })
            .then((data: RemoveLineItemResponseData) => {
                dispatch(removeLineItemSuccess(partNumber, orderItemId, data))
                notifyBasketChanged()
            })
            .catch((error: unknown) => {
                dispatch(removeLineItemError(partNumber, orderItemId, error))
                throw error
            })
    }
}

function removeLineItemRequest(partNumber: string, orderItemId: number) {
    return {
        type: REMOVE_ITEM_REQUEST,
        partNumber,
        orderItemId,
    }
}

function removeLineItemSuccess(partNumber: string, orderItemId: number, payload: RemoveLineItemResponseData) {
    return {
        type: REMOVE_ITEM_SUCCESS,
        partNumber,
        orderItemId,
        payload,
    }
}

function removeLineItemError(partNumber: string, orderItemId: number, error: unknown) {
    return {
        type: REMOVE_ITEM_ERROR,
        partNumber,
        orderItemId,
        error,
    }
}
